import React, { useState, useEffect } from 'react'
import "./universal-filter-prompt.css"

const UniversalFilterPrompt = ({ show, changeType, filterType, onApplyToAll, onApplyToCurrentOnly, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setIsClosing(false);
    }
  }, [show]);

  const filterNames = { bw: 'שחור לבן', bluewhite: 'כחול לבן' };
  
  const promptMessages = {
    ADD: {
      bw: {
        header: 'פילטר לכל התמונות?',
        body: 'תרצו להפעיל את הפילטר על שאר התמונות?',
        currentOnly: 'תצבע רק את זו',
        applyAll: 'צבעו את כולן'
      },
      bluewhite: {
        header: 'זיהינו שבחרתם פילטר צבע', 
        body: 'תרצו להפעיל את הפילטר על שאר התמונות?',
        currentOnly: 'צבעו רק את זו',
        applyAll: 'צבעו את כולן'
      }
    },
    REMOVE: {
      bw: {
        header: 'להסיר פילטר מכל התמונות?',
        body: 'תרצו להסיר את הפילטר גם משאר התמונות?',
        currentOnly: 'הסירו רק מזו', 
        applyAll: 'הסירו מכולן'
      },
      bluewhite: {
        header: 'זיהינו שהסרתם פילטר צבע',
        body: 'תרצו להסיר את הפילטר גם משאר התמונות?', 
        currentOnly: 'הסר רק מזו',
        applyAll: 'הסירו מכולן'
      }
    }
  };
  
  const messages = promptMessages[changeType]?.[filterType];
  
  if (!messages) {
    return null;
  }

  return (
    <div className={`universal-filter-prompt ${show ? "show" : ""} ${isClosing ? "closing" : ""}`}>
      <div onClick={e => e.stopPropagation()} className="universal-filter-prompt-content">
        <div className="universal-filter-prompt-header">
          <p dir="rtl">{messages.header}</p>
        </div>
        {/* <div className="universal-filter-prompt-body">
          <p>{messages.body}</p>
        </div> */}
        <div className="universal-filter-prompt-footer">
          <p className="universal-filter-prompt-text" onClick={onApplyToCurrentOnly}>
            {messages.currentOnly}
          </p>
          <button onClick={() => {
            // Small delay to allow active state animation to show
            setTimeout(() => {
              setIsClosing(true);
            }, 100);
            setTimeout(() => {
              onApplyToAll();
            }, 900);
          }} className="universal-filter-prompt-button">
            {messages.applyAll}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UniversalFilterPrompt;